import { useEffect } from "react";

export const Seo = ({ title, description, canonical, schema }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical || `https://trademind.cz${window.location.pathname}`);
    const prev = document.getElementById("seo-jsonld");
    if (prev) prev.remove();
    if (schema) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "seo-jsonld";
      s.textContent = JSON.stringify(schema);
      document.head.appendChild(s);
    }
    return () => {
      const el = document.getElementById("seo-jsonld");
      if (el) el.remove();
    };
  }, [title, description, canonical, schema && JSON.stringify(schema)]);
  return null;
};
